import { apiFetch } from '@/shared/lib/apiClient';
import type {
  IssueParticipantResponse,
  UserResponseDto,
} from '@/shared/lib/apiTypes';

/**
 * 신규 유저 코드를 서버에 발급 요청한다.
 *
 * Swagger: `GET /api/join/code` — 6자리 영숫자 유저 코드를 자동 생성하여 신규 익명 유저를 만든다.
 * 응답에는 발급 시각이 포함되지 않으므로 클라이언트가 수신 직후 채워 넣는다.
 *
 * @returns 발급된 유저 코드와 클라이언트 수신 시각.
 * @throws ApiError(429) 회원가입 호출 제한(1분당 5회) 초과 시.
 */
export async function issueParticipant(): Promise<IssueParticipantResponse> {
  const response = await apiFetch<UserResponseDto>('/api/join/code', {
    method: 'GET',
  });
  return {
    code: response.userCode,
    createdAt: new Date().toISOString(),
  };
}
